import { PHYSICS_VERSION, PROTOCOL_VERSION } from "@air-hockey/game-core";
import type { PlayerSlot } from "./types";

export interface ActiveMatchResume {
  version: 1;
  matchId: string;
  wsUrl: string;
  slot: PlayerSlot;
  playerId: string;
  localName: string;
  opponentName: string;
  protocolVersion: string;
  physicsVersion: string;
  expiresAt: number;
}

const ACTIVE_MATCH_STORAGE_KEY = "air-hockey.active-match.v1";

export function readActiveMatchResume(): ActiveMatchResume | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(ACTIVE_MATCH_STORAGE_KEY) ?? "null") as Partial<ActiveMatchResume> | null;
    if (
      !value ||
      value.version !== 1 ||
      value.protocolVersion !== PROTOCOL_VERSION ||
      value.physicsVersion !== PHYSICS_VERSION ||
      typeof value.matchId !== "string" ||
      typeof value.wsUrl !== "string" ||
      (value.slot !== "A" && value.slot !== "B") ||
      typeof value.playerId !== "string" ||
      typeof value.localName !== "string" ||
      typeof value.opponentName !== "string" ||
      typeof value.expiresAt !== "number" ||
      value.expiresAt <= Date.now()
    ) {
      removeActiveMatchResume();
      return null;
    }
    const url = new URL(value.wsUrl);
    if ((url.protocol !== "ws:" && url.protocol !== "wss:") || !url.searchParams.get("ticket")) {
      removeActiveMatchResume();
      return null;
    }
    return value as ActiveMatchResume;
  } catch {
    removeActiveMatchResume();
    return null;
  }
}

export function persistActiveMatchResume(resume: ActiveMatchResume): void {
  try {
    sessionStorage.setItem(ACTIVE_MATCH_STORAGE_KEY, JSON.stringify(resume));
  } catch {
    // Recovery remains in memory when session storage is blocked.
  }
}

export function removeActiveMatchResume(): void {
  try {
    sessionStorage.removeItem(ACTIVE_MATCH_STORAGE_KEY);
  } catch {
    // Nothing else to clear when session storage is blocked.
  }
}
